export default __webpack_public_path__ + "static/media/fintof.2e035b6a.png";